<template>
    <div class="share-links">
        <span class="sn">
            <a
                v-for="(shareLink, index) in shareLinks"
                :key="shareLink.id + '-' + index"
                class="iconfont"
                :class="shareLink.icon"
                :href="shareLink.url"
                :aria-label="shareLink.socialNetwork"
                target="_blank"
                rel="noopener noreferrer"
            ></a>
        </span>
    </div>
</template>

<script>
import { ICON_MAP_WITH_AGENT as SPECIAL_ICON_MAP } from '../icon-map';
import util from '@/common/util.js';
export default {
    props: {
        socialNetworks: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        shareLinks() {
            let list = util.deepClone(this.socialNetworks);
            const shareLinks = list.filter(item => {
                item.icon =
                    SPECIAL_ICON_MAP[item.socialNetwork] ||
                    'icon-agent-' + item.socialNetwork;
                return !!item.socialNetwork && !!item.url;
            });
            return shareLinks;
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
.md-team.broker-float {
    .share-links {
        width: 100%;
        @include media-600 {
            margin-bottom: 20px;
        }
        .sn {
            font-size: 0;
            width: 100%;
            overflow-y: hidden;
            height: auto;
            display: flex;
            white-space: nowrap;
            overflow-x: scroll;
            align-items: center;
            &::-webkit-scrollbar {
                width: 0;
                height: 0;
            }
            .iconfont {
                display: inline-flex;
                margin-bottom: 0;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                overflow: hidden;
                font-size: 16px;
                text-align: center;
                color: #000;
                background: #e5e5e5;
                cursor: pointer;
                align-items: center;
                justify-content: center;
                margin-right: 10px;
                &:hover {
                    color: #fff;
                }
                &.icon-agent-facebook {
                    &:hover {
                        background-color: #4063b3;
                    }
                }
                &.icon-agent-linkedin {
                    &:hover {
                        background-color: #0a8dcb;
                    }
                }
                &.icon-a-newagent-detail-twitter1 {
                    &:hover {
                        background-color: #000;
                    }
                }
                &.icon-agent-zillow {
                    &:hover {
                        background-color: #006aff;
                    }
                }
                &.icon-agent-yelp {
                    &:hover {
                        background-color: #af0606;
                    }
                }
                &.icon-agent-yelp {
                    &:hover {
                        background-color: #af0606;
                    }
                }
                &.icon-instagram {
                    &:hover {
                        background-image: linear-gradient(
                            44deg,
                            #f7de01 6%,
                            #f92002 40%,
                            #dd1e49 52%,
                            #b12973 62%,
                            #7837aa 87%
                        );
                    }
                }
                &.icon-youtube1 {
                    &:hover {
                        background-color: #f00;
                    }
                }
                &.icon-snapchat {
                    &:hover {
                        background-color: #eddb02;
                    }
                }
                &.icon-agent-pinterest {
                    &:hover {
                        background-color: #e70023;
                    }
                }
                &.icon-angelist-square {
                    &:hover {
                        background-color: #191919;
                    }
                }
                &.icon-google2 {
                    &:hover {
                        background-color: #ea4336;
                    }
                }
                &.icon-agent-whatsapp {
                    &:hover {
                        background-color: #1acf40;
                    }
                }
                &.icon-redfin-simple {
                    &:hover {
                        background-color: #c82021;
                    }
                }
                @include media-600 {
                    width: 26px;
                    height: 26px;
                    margin-right: 10px;
                    font-size: 12px;
                    flex-shrink: 0;
                }
                &:last-child {
                    margin-right: 0;
                }
            }

            .icon-agent-zillow,
            .icon-agent-yelp {
                font-size: 14px;
            }
            .icon-instagram {
                font-size: 18px;
            }
        }
    }
}
</style>
